
export enum ValueType {
    CC = 1,
    PRICE = 2,
    BOTH = 3
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/value-type.enum.ts